import { Routes, Route } from "react-router-dom";
import NaoEncontrada from "./pages/(public)/NaoEncontrada";
import Inicio from "./pages/Inicio";
import Chamado from "./pages/(private)/Chamado";
import Chamados from "./pages/(private)/Chamados";
import ProtectedRoute from "./components/ProtectedRoute";
import AreaDoCliente from "./pages/(public)/AreaDoCliente";
import Estoque from "./pages/(private)/Estoque";
import Unauthorized from "./pages/(public)/NaoAutorizado";

const Router = () => {
  return (
    <Routes>
      <Route index element={<Inicio />} />
      <Route path="/area-do-cliente" element={<AreaDoCliente />} />

      <Route element={<ProtectedRoute allowedLevels={["1"]} />}>
        <Route path="/estoque" element={<Estoque />} />
      </Route>

      <Route element={<ProtectedRoute allowedLevels={["1", "2"]} />}>
        <Route path="/chamados" element={<Chamados />} />
        <Route path="/chamado" element={<Chamado />} />
      </Route>

      <Route path="*" element={<NaoEncontrada />} />
      <Route path="/nao-autorizado" element={<Unauthorized />} />
    </Routes>
  );
};

export default Router;
